export const AUCTION_STATUS = {
  LIVE: "Live",
  NOT_STARTED: "NOT_STARTED",
  ENDED: "Ended",
};
